require('./bootstrap-vue')
require('./vue-axios')
require('./moment')
require('./vue-toasted')
require('./vee-validate')
require('./xlsx.js')
require('./font-awesome')
require('./vue-multiselect')
